@if (inputService.show) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field [appearance]='inputService.inputConfig.appearence'>
      <mat-label>
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
        <span>{{inputService.computedTitle | translate}}</span>
      </mat-label>
      @if (inputService.inputConfig.readOnly) {
        <input matInput readonly [matTooltip]='selectedLabel' [value]='selectedLabel'/>
      }
      @if (!inputService.inputConfig.readOnly) {
        <mat-select [matTooltip]='selectedLabel' [placeholder]="inputService.inputConfig.placeholder | translate" [formControlName]='inputService.formControlKey' multiple>
          <input class="myInput"
            matInput
            selectPanelSearch
            [required]='inputService.inputConfig.required'
            type="text"
            (input)="search($event.target.value)"
            autocomplete="off"
            [placeholder]="'Cerca' | translate">
          @if (loading) {
            <mat-progress-bar mode='indeterminate' ></mat-progress-bar>
          }
          <mat-divider></mat-divider>
          @for (selectOption of selectOptions; track selectOption) {
            <mat-option [value]='selectOption.value'>
              @if (inputService.formInputDefinition.remoteOptions.icon) {
                <mat-icon>{{inputService.formInputDefinition.remoteOptions.icon}}</mat-icon>
              }
              <span [innerHTML]='selectOption.label'></span>
            </mat-option>
          }
        </mat-select>
      }
      @if (loading) {
        <mat-spinner diameter="20" matSuffix></mat-spinner>
      }
      @if (!loading && inputService.control.value && !inputService.inputConfig.readOnly) {
        <mat-icon matSuffix style='cursor: pointer;' (click)='inputService.control.setValue(null)'>close</mat-icon>
      }
      @if (!inputService.control.valid) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
    </mat-form-field>
  </ng-container>
}